// External libs
import { createAction } from '@reduxjs/toolkit'

const closeAction = createAction('CheckErrorServiceDialog/close')

const clearAction = createAction('CheckErrorServiceDialog/clear')

const maximizeAction = createAction('CheckErrorServiceDialog/maximize')

const openAction = createAction('CheckErrorServiceDialog/open')

const clear = () => (dispatch: any) => {
  dispatch(clearAction())
}

const close = () => (dispatch: any) => {
  dispatch(closeAction())
}

const maximize = () => (dispatch: any) => dispatch(maximizeAction())

const open = () => async (dispatch: any) => {
  dispatch(openAction())
}

const actions = {
  clear,
  clearAction,
  close,
  closeAction,
  maximize,
  maximizeAction,
  open,
  openAction,
}

export default actions
